import React from 'react';
import { MdEmail } from 'react-icons/md';
import { FaLinkedin, FaTelegramPlane } from 'react-icons/fa';

export default function ContactMe() {
    return (
        <section className="bg-gray-100 py-16">
            <div className="container mx-auto px-4 text-center">
                <div className="bg-white p-10 rounded-2xl shadow-xl inline-block">
                    <h2 className="text-3xl md:text-4xl font-bold mb-4 text-gray-800">Contact Me</h2>
                    <p className="text-lg text-gray-600 mb-6">
                        Feel free to reach out to me via email or connect on LinkedIn or Telegram.
                        <br />
                        I'm always open to new opportunities and discussions. Let's connect and explore the possibilities together!
                    </p>
                    <div className="flex flex-wrap justify-center items-center gap-4">
                        <a
                            href="mailto:kritikagarwal@ymail.com"
                            aria-label="Email Kritik Agarwal"
                            className="flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-full hover:bg-blue-700 transition min-w-[200px] justify-center"
                        >
                            <MdEmail size={18} />
                            Email Me
                        </a>
                        <a
                            href="https://in.linkedin.com/in/AgarwalKritik"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Connect with Kritik Agarwal on LinkedIn"
                            className="flex items-center gap-2 bg-blue-800 text-white px-6 py-3 rounded-full hover:bg-blue-900 transition min-w-[200px] justify-center"
                        >
                            <FaLinkedin size={18} />
                            Connect on LinkedIn
                        </a>
                        <a
                            href="https://telegram.me/kritikbondia"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Message Kritik Agarwal on Telegram"
                            className="flex items-center gap-2 bg-blue-400 text-white px-6 py-3 rounded-full hover:bg-blue-500 transition min-w-[200px] justify-center"
                        >
                            <FaTelegramPlane size={18} />
                            Message on Telegram
                        </a>
                    </div>
                </div>
            </div>
        </section>
    );
}
